// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chip-container[data-v-71f77df0] {\n  height: 30px;\n}\n.flex-center[data-v-71f77df0] {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.flex-column[data-v-71f77df0] {\n  flex-direction: column;\n}\n", ""]);
// Exports
module.exports = exports;
